import { CircularProgress } from '@material-ui/core';
import React from 'react';
export const Loader = () => {
    return (React.createElement("div", { className: "loader u-align-horizontal-center" },
        React.createElement(CircularProgress, { size: 36 })));
};
